module.exports = __webpack_public_path__ + "static/photo14@2x-cdd31ecd80f14258e7ac80aaa762cd63.png";